import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { JsonPipe, KeyValuePipe } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, NonNullableFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { z } from 'zod';
import { mapValidities, transformCSVToDataRecords } from '@r1-compass-library/models';

@Component({
    selector: 'r1-compass-app-zod-example',
    imports: [KeyValuePipe, MatSelectModule, MatFormFieldModule, ReactiveFormsModule, JsonPipe, FormsModule],
    template: `
        <!--        <pre>validityMappings: {{ validityMappings() | json }}</pre>-->
        <form [formGroup]="form">
            <mat-form-field>
                <mat-label>Select a Field</mat-label>
                <mat-select formControlName="selectedField">
                    @for (mapping of validityMappings(); track $index) {
                        @for (field of mapping | keyvalue; track $index) {
                            <mat-option [value]="field.key" (click)="form.controls.type.reset()">{{
                                field.key
                            }}</mat-option>
                        }
                    }
                </mat-select>
            </mat-form-field>

            @for (mapping of validityMappings(); track $index) {
                @for (field of mapping | keyvalue; track $index) {
                    @if (field.key === form.controls.selectedField.value) {
                        <mat-form-field>
                            <mat-label>Field Type</mat-label>
                            <mat-select formControlName="type">
                                @for (type of field.value | keyvalue; track $index) {
                                    <mat-option [value]="type.key">{{ type.key }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    }
                }
            }
            <pre>form value: {{ form.value | json }}</pre>
        </form>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ZodExampleComponent {
    readonly #fb = inject(NonNullableFormBuilder);

    form = this.#fb.group({
        selectedField: this.#fb.control<string>(''),
        type: this.#fb.control<string>(''),
    });

    validityMappings = computed(() => {
        const data: string[][] = [
            ['dateCol', 'numCol'],
            ['6/26/2016', 'abc'],
        ];

        return (
            mapValidities(
                transformCSVToDataRecords(data),
                ['integer', 'varchar', 'numeric', 'date', 'timestamptz', 'currency'],
                true
            ) ?? []
        );
    });

    constructor() {
        const parse = z.coerce.date().safeParse('3/26/2013');
        console.debug(parse);

        const dates: string[] = [];

        dates.forEach(d => {
            console.debug(d, z.coerce.date().safeParse(d));
        });
    }
}
